<div class="app-shell">
  <app-navbar></app-navbar>
  <main class="app-main">
    <router-outlet></router-outlet>
  </main>
  <app-tab-bar></app-tab-bar>
  <app-toast-container></app-toast-container>
</div>
